import { useQuery } from '@tanstack/react-query';

import { GHADiscountSummaryFilters, getCugLeakSummary } from '~/services/ConnectionGoogleService';

export const cugLeakSummaryQueryKeys = {
  all: ['cugLeakSummary'] as const,
  summary: (filters: GHADiscountSummaryFilters) => [...cugLeakSummaryQueryKeys.all, filters] as const,
};

export function useCugLeakSummary(filters: GHADiscountSummaryFilters = {}) {
  return useQuery({
    queryKey: cugLeakSummaryQueryKeys.summary(filters),
    queryFn: async ({ signal }) => {
      const response = await getCugLeakSummary(filters, { signal });
      return response.result;
    },
    // The rollup is several full property-table scans server-side; keep it fresh for 5 minutes
    // so switching sub-tabs doesn't re-pay that cost. The Refresh button refetches regardless.
    staleTime: 5 * 60 * 1000,
  });
}
